import { generateBFFUrl, DISPOSITONS } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';

export const fetchDispositions = async (
  deviceId: string,
  warrantyStatus: string,
  hubCode: string,
  isIrRequired: boolean,
  daysToExpire: number,
  serverCookie?: any,
): Promise<any> => {
  const dispositions = await axiosInstance
    .get(generateBFFUrl(`${DISPOSITONS}/${deviceId}`), {
      headers: generateHttpHeaders(serverCookie),
      params: {
        warrantyStatus,
        isIrRequired,
        hubCode,
        daysToExpire,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error: any) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return dispositions;
};
